import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import Button from 'src/shared-components/Button';
import { InputField } from 'src/shared-components/Form';
import * as Yup from 'yup';
interface SetRateFormProps {
  minimumRate?: number;
  submitForm: (values: any) => void;
  buttonText?: string;
}
const SetRateForm = ({ minimumRate, submitForm, buttonText = 'Submit' }: SetRateFormProps) => {
  const form = useFormik({
    initialValues: {
      minimumRate: 0,
    },
    onSubmit: values => {
      submitForm(values);
    },
    validationSchema: Yup.object({
      minimumRate: Yup.number()
        .typeError('Please enter a number')
        .positive('Please enter a positive value')
        .required('Please enter your minimum rate'),
    }),
  });

  const { isValid, handleSubmit, setFieldValue, values, errors, handleBlur, setValues } = form;

  minimumRate = minimumRate ?? 0;

  useEffect(() => {
    form.setValues({ minimumRate });
  }, [minimumRate]);

  const roundMinimumRate = e => {
    handleBlur(e);
    if (!errors.minimumRate) setFieldValue('minimumRate', Math.round(e.target.value));
  };

  return (
    <FormikProvider value={form}>
      <div className="flex flex-col gap-y-5">
        <InputField
          required
          name="minimumRate"
          label="MINIMUM RATE"
          placeholder="Set your minimum hourly rate..."
          onBlur={e => roundMinimumRate(e)}
          type="number"
          prefix="$"
        />
        <Button
          onClick={() => handleSubmit()}
          size="lg"
          className="mt-4"
          roundness="md"
          color="black"
          fullWidth
          disabled={!isValid}
        >
          {buttonText}
        </Button>
      </div>
    </FormikProvider>
  );
};
export default SetRateForm;
